import React from 'react';

class ProductErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('❌ Error en Product Page:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 40 }}>
          <h2>Error cargando el producto</h2>
          <p>Ocurrió un error al renderizar esta página.</p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ProductErrorBoundary;
